import { ContentTrackTypes } from './ContentTrackTypes';
import { IContentPlaylist } from './IContentPlaylist';

export class ContentCue {
	public endDateTime: Date;
	public startDateTime: Date;

	constructor(
		private initialProgramDateTime: Date,
		public contentPlaylist: IContentPlaylist,
		public type: ContentTrackTypes,
		public startSecs: number,
		public endSecs: number,
		public contentPlaylistStartDateTime: Date,
		public isInitial: boolean
	) {
		this.endDateTime = this._getOffsetDateTime(initialProgramDateTime, endSecs);
		this.startDateTime = this._getOffsetDateTime(initialProgramDateTime, startSecs);
	}

	public isActiveAt(currentDateTime): boolean {
		return currentDateTime >= this.startDateTime && ((typeof this.contentPlaylist.end !== 'number') || currentDateTime < this.endDateTime);
	}

	public updateEndSecs(endSecs: number): void {
		this.contentPlaylist.end = endSecs;
		this.endDateTime = this._getOffsetDateTime(this.initialProgramDateTime, endSecs);
	}

	private _getOffsetDateTime(initialDateTime: Date, offsetSecs: number): Date {
		const offsetMs: number = offsetSecs * 1000;

		return new Date(initialDateTime.getTime() + offsetMs);
	}

	public isCompleted(): boolean {
		return this.contentPlaylist.start != null && this.contentPlaylist.end != null;
	}
}
